module.exports = __webpack_public_path__ + "img/banner1.d0f858b6.png";